import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
  selector: 'dmmp-form-survey',
  templateUrl: './survey.component.html',
})
export class SurveyComponent implements OnInit {
  @Input() survey
  @Output() changeModel: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit() {
  }
}
